/* Tartan fabric listing: turns a premium tartan and the rush request into extra cart lines, like the kilt options panel does. */
(function () {
  document.querySelectorAll('[data-a1-fabric]').forEach(function (panel) {
    var variants = {};
    try { variants = JSON.parse(panel.querySelector('[data-a1-customisation-variants]').textContent || '{}'); } catch (e) {}
    function line(key) {
      var id = Number(variants[key]);
      return id ? { id: id, quantity: 1, properties: { 'Paired with': panel.dataset.productTitle, '_Customisation': key } } : null;
    }
    panel.accessoryItems = function () {
      var items = [];
      var tartan = panel.querySelector('[name="properties[Tartan Colour]"]');
      var m = tartan && tartan.value.match(/\(\+\$(\d+)\)/);
      if (m) { var a = line('Tartan colour premium (+$' + m[1] + ')'); if (a) items.push(a); }
      panel.querySelectorAll('select[data-a1-paid]').forEach(function (sel) {
        var pm = sel.value.match(/\(\+\$(\d+)\)/);
        if (!pm) return;
        var l = line('Set add-on (+$' + pm[1] + ')');
        if (l) { l.properties.Item = sel.name.slice(11, -1) + ': ' + sel.value.replace(/ \(\+\$\d+\)$/, ''); items.push(l); }
      });
      var rush = panel.querySelector('[name="properties[Rush Order]"]');
      if (rush && rush.checked) { var b = line('Rush order: ' + rush.value); if (b) items.push(b); }
      return items;
    };
  });
})();
